<template>
    <div>
        <div class="text-center">
            Press the button below to activate this integration, you will be notified as soon as it gets activated.
        </div>

        <div class="d-flex justify-content-center mt-3">
            <button class="btn blue" @click="clickActivate()" :disabled="isActivating">Activate</button>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data() {
            return {
                isActivating: false
            }
        },
        props: {
            integration: {
                type: Object,
                required: true
            }
        },
        methods: {
            ...mapActions([
                'requestIntegrationActivationViaEmail',
                'createViatorIntegration',
                'enableOrDisableViatorIntegration'
            ]),
            clickActivate() {
                if (!this.integration) return;

                const { name, label, integrationStatus } = this.integration;
                this.isActivating = true;

                // Viator: create or enable/disable integration
                if (name === 'Viator' || label === 'Viator') {
                    if (integrationStatus === 4) {
                        // If it doesn't exist, create the integration
                        this.createViatorIntegration();
                    } else {
                        // If it exists, enable or disable it based on the current state
                        const shouldActivate = integrationStatus === 0;
                        this.enableOrDisableViatorIntegration(shouldActivate);
                    }

                    this.isActivating = false;
                    this.$emit('close');
                    
                    return;
                }

                // Other integrations: activation request via email
                this.requestIntegrationActivationViaEmail(this.integration)
                .then(() => { this.$emit('close') })
                .catch(() => {})
                .finally(() => { this.isActivating = false });
            }
        }
    }
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// requestActivation.vue?f8d0bad2